import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserAdminForm } from "app/interfaces/useradmin-form.interface";

const usersAdminUrlApi = environment.usersAdminUrlApi;
const usersAdminWithFiltersUrlApi = environment.usersAdminWithFiltersUrlApi;
const blockUnblockUserAdminById = environment.blockUnblockUserAdminById;

@Injectable()
export class UserAdminService {
  public user: UserAdminForm;

  constructor(private http: HttpClient) {}

  getUsers() {
    return this.http
      .request("GET", `${usersAdminUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getUsersWithFilter(filters) {
    const params = filters;
    console.log(params);
    return this.http
      .post(`${usersAdminWithFiltersUrlApi}`, params)
      .pipe(map((resp: any) => resp));
  }

  getUserById(id: number) {
    return this.http
      .request("GET", `${usersAdminUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateUserById(id: number, userModel: UserAdminForm) {
    console.log(id);
    console.log(userModel);
    delete userModel.active;
    const body = userModel;
    return this.http
      .request("PUT", `${usersAdminUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createUser(userModel: UserAdminForm) {
    console.log(userModel);
    delete userModel.password2;
    delete userModel.active;
    const body = userModel;
    return this.http
      .request("POST", `${usersAdminUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  changeStatusUserById(id: number, status: boolean) {
    const body = { active: !status };
    return this.http
      .request("PUT", `${blockUnblockUserAdminById}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteUserById(id: number) {
    return this.http
      .request("DELETE", `${usersAdminUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
}
